import React from "react";
import { motion } from "framer-motion";
import {
  FaCog,
  FaTools,
  FaIndustry,
  FaRocket,
  FaCertificate,
  FaUsers,
  FaAward,
  FaEye,
  FaBullseye,
} from "react-icons/fa";
import ElectronicImage from "../../assets/dexter-images/electronic.jpg";
import Aerospace from "../../assets/dexter-images/aerospace.jpg";

function AboutPage() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h1>About DexteR Technology</h1>
            <p>Precision Manufacturing Excellence Since 2022</p>
          </motion.div>
        </div>
      </section>

      <section className="about-content-section">
        <div className="container">
          {/* First Section: Two paragraphs left, image right */}
          <div className="about-content-row">
            <motion.div
              className="about-text-content"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="text-block">
                <h2>Who We Are</h2>
                <p>
                  "DexteR Technology" is a Customized parts manufacturing
                  company that offers end to end services for complex, high
                  precision mechanical requirements from importing raw material,
                  process documentation to post-machining special processes and
                  sub-assemblies. We supply fully finished precision parts or
                  mechanical kits ready for further integration.
                </p>
                <p>
                  Established in 2022 & Export Oriented Unit, DexteR Technology
                  specializes in delivering solutions as a prominent
                  manufacturer and supplier of a range of Precise Components,
                  Gear Box Assembly, Machine Spare Parts, Shafts, Flange and
                  other Industrial Components in SS, Aluminum, Brass, Gun Metal
                  and MS. These products are lauded for their features like
                  durability, rust resistance and easy installation.
                </p>
              </div>
            </motion.div>

            <motion.div
              className="about-image-content"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="image-container">
                <img
                  src={ElectronicImage}
                  alt="DexteR Technology Manufacturing Facility"
                />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <h4>State-of-the-Art Facility</h4>
                    <p>Advanced machines with 10-micron precision</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Second Section: Image left, three paragraphs right */}
          <div className="about-content-row reverse">
            <motion.div
              className="about-image-content"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="image-container">
                <img
                  src={Aerospace}
                  alt="DexteR Technology Manufacturing Process"
                />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <h4>Precision Manufacturing</h4>
                    <p>Advanced turning and milling capabilities</p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              className="about-text-content"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="text-block">
                <h2>Our Expertise & Services</h2>
                <p>
                  We have brought forth to our clients one of the most exciting
                  and reliable services for Machinery. We hold expertise in all
                  kinds of Machinery works ranging from minute to bigger level,
                  Milling works, conventional lathe works & fabrication works in
                  a very trustworthy manner. These services are available for
                  our clients at a very conventional and attractive range of
                  prices at our company.
                </p>
                <p>
                  Our products are highly acclaimed by the clients due to their
                  several features such as high performance, dimensional
                  precision, excellent resistance against corrosion and
                  cost-effectiveness. Our components can also be designed as per
                  the specific requirements of clients. Furthermore, the product
                  range that we offer is manufactured in compliance with the
                  international standards of quality.
                </p>
                <p>
                  This service is handled by experts who use advanced techniques
                  to render this service as per customer's demand. These experts
                  make judicious utilization of resources and their experience
                  to offer impeccable products and services. Further, we have
                  appointed quality controllers who ensure that our products are
                  tested on several parameters to determine their defect free
                  nature and flawless quality.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="about-cards">
        <div className="container">
          <div className="cards-grid">
            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaCog />
              </div>
              <h3>TURNED COMPONENTS</h3>
              <p>
                "Concept to Component" being key to our business, DexteR
                Technology has invested in sophisticated Machines, Special
                Tooling and Precision Instruments to perform intricate machining
                with Close Tolerance (upto 10 Microns). DexteR Technology has
                with VMC machines with proper inspection & testing facility to
                complete their work.
              </p>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaTools />
              </div>
              <h3>RAW MATERIAL</h3>
              <p>
                DexteR Technology is a precision manufacturing company that has
                a good understanding of the projects & we have been sourcing raw
                material as per ASTM, AMS standards for Aluminum, steel, custom
                steels, etc.
              </p>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaIndustry />
              </div>
              <h3>Services</h3>
              <ul>
                <li>CNC Turning</li>
                <li>VMC Milling</li>
                <li>Custom Part Manufacturing</li>
                <li>Prototyping</li>
                <li>Small/Large Batch Production</li>
                <li>3D CAD/CAM Design</li>
                <li>Finishing & Assembly</li>
                <li>Materials you work with (aluminum, steel, Brass, etc.)</li>
                <li>Traub Works</li>
                <li>Grinding</li>
                <li>Hobbing & Milling</li>
              </ul>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaRocket />
              </div>
              <h3>Capabilities</h3>
              <ul>
                <li>Solid Foundation for Cutting</li>
                <li>Forging</li>
                <li>Casting</li>
                <li>Machining</li>
                <li>Harding</li>
                <li>Gridding</li>
              </ul>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaCertificate />
              </div>
              <h3>Quality Assurance / Certifications</h3>
              <ul>
                <li>Details on quality control processes</li>
                <li>Measuring tools and inspection equipment used</li>
                <li>ISO or other industry certifications</li>
                <li>2D Digital Height Master </li>
                <li>Contour Measurement </li>
                <li>Surface Roughness Tester </li>
                <li>Digital Micrometers, Verniers, and Inside Calipers </li>
                <li>3-Pin Micrometers </li>
              </ul>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaUsers />
              </div>
              <h3>Industries Served</h3>
              <ul>
                <li>Aerospace</li>
                <li>Automotive</li>
                <li>Medical</li>
                <li>Electronics</li>
                <li>Industrial Machinery</li>
                <li>Custom Manufacturing</li>
              </ul>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaAward />
              </div>
              <h3>Why Choose Us?</h3>
              <p>
                Choosing DexteR Technology means partnering with a company that
                values quality, innovation, and reliability. With over three
                years of experience in the industry, we have a proven track
                record of delivering high-quality engineering parts on time. Our
                state-of-the-art machinery and strict quality control processes
                ensure that every product meets the highest standards. We are
                committed to continuous improvement and customer satisfaction,
                making us the ideal choice for your engineering needs. Our
                dedicated team of skilled professionals, along with our
                extensive industry knowledge, enables us to provide customized
                solutions that meet the unique requirements of each client.
              </p>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaEye />
              </div>
              <h3>Our Vision</h3>
              <p>
                At DexteR Technology, our vision is to be recognized as a global
                leader in the engineering parts industry. We aim to achieve this
                by continuously pushing the boundaries of innovation, quality,
                and customer satisfaction. We envision a future where our name
                is synonymous with excellence, reliability, and cutting-edge
                solutions. By staying ahead of industry trends and embracing new
                technologies, we seek to set new standards in product
                development and manufacturing processes. Our commitment to
                sustainability and ethical practices will guide our growth as we
                expand our product range and global reach. Ultimately, we strive
                to be the preferred partner for businesses worldwide,
                contributing to their success through our expertise and
                unwavering dedication to excellence.
              </p>
            </motion.div>

            <motion.div
              className="about-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.9 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="card-icon">
                <FaBullseye />
              </div>
              <h3>Our Mission</h3>
              <p>
                At DexteR Technology, our mission is to deliver exceptional
                engineering parts that not only meet but exceed our customers'
                expectations.
              </p>
              <p>
                We are committed to achieving this through innovative
                manufacturing processes, stringent quality control, and a
                steadfast customer-centric approach. Our focus on building
                long-term relationships with our clients drives us to provide
                unparalleled products and services.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
